<template>
	<div id="qe_index">
		<dv-full-screen-container class="bg bg-video">
			<div v-on:click="screen()"><dv-decoration-9 :color="['#55ffff', '#0090ff']" class="full_screen">{{screenName}}</dv-decoration-9></div>
			<video autoplayloopposter="polina.jpg" class="bgvid" id="bgvid" autoplay muted loop>
				<source src="../../assets/img/qualitySchBg.mp4" type="video/mp4">
			</video>
			<dv-loading v-if="loading">Loading...</dv-loading>
			<div v-else class="host-body">
				<div v-on:click="screen()"><dv-decoration-9 :color="['#55ffff', '#0090ff']" class="full_screen">{{screenName}}</dv-decoration-9></div>
				<!-- 第一行标题装饰条 -->
				<div class="d-flex jc-center title_bg">
					<div class="title">
						<span class="title-text">&#9658; {{ areaName }}</span>
					</div>
				</div>
				<div class="term">
					<div class="term_txt" @click="termFlag = !termFlag">{{ termName }} <span>&#9660;</span></div>
					<div class="term_list" ref="termDorm" v-show="termFlag">
						<ul>
							<li v-on:click="checkTerm('2023-2024第一学期', 1)" :class="termIndex == 1 ? 'on' : ''"> 2023-2024第一学期</li>
							<li v-on:click="checkTerm('2022-2023第二学期', 2)" :class="termIndex == 2 ? 'on' : ''"> 2022-2023第二学期</li>
							<li v-on:click="checkTerm('2022-2023第一学期', 3)" :class="termIndex == 3 ? 'on' : ''"> 2022-2023第一学期</li>
						</ul>
					</div>
				</div>
				<div class="body-box">
					<!-- 第三行数据开始 -->
					<div class="w-100 content-box">
						<div class="main_grid">
							<!-- 第一列 -->
							<div>
								<div class="l_block">
									<dv-border-box-13 :color="['#0575e6', '#00e6f2']">
										<left1 ref="left1"/>
									</dv-border-box-13>
								</div>
								<div class="l_block">
									<dv-border-box-13 :reverse="true" :color="['#0575e6', '#00e6f2']">
										<left2 ref="left2"/>
									</dv-border-box-13>
								</div>
								<div class="l_block">
									<dv-border-box-13 :color="['#0575e6', '#00f2f2']">
										<left3 ref="left3"/>
									</dv-border-box-13>
								</div>
							</div>
							<!-- 第一列结束 -->
							<!-- 第三列 -->
							<div>
								<!-- 学生统计开始 -->
								<div class="mt_block">
									<!-- 左边 -->
									<div class="b_block">
										<div class="block_bnum"><b class="colorbluegreen">{{ studentNum }}</b></div>
										<div class="title-item">参与学生数</div>
									</div>

									<div class="b_block">
										<div class="block_bnum"><b class="colorYellow">{{ hasEvalNum }}</b></div>
										<div class="title-item">已评学生数</div>
									</div>

									<div class="b_block">
										<div class="block_bnum"><b class="colorBlue">{{ notEvalNum }}</b></div>
										<div class="title-item">未评学生数</div>
									</div>
								</div>
								<!-- 学生统计结束 -->
								<div class="center_mt">
									<dv-border-box-11 :color="['#06ebff', '#124a8f']">
										<center1 ref="center1"/>
									</dv-border-box-11>
								</div>
								<!-- 下半部分 -->
								<div class="center_btm">
									<!-- 老师评价工作 -->
									<dv-border-box-1 :color="['#0575e6', '#00caf2']">
										<center2 ref="center2"/>
									</dv-border-box-1>
								</div>
								<!-- 下半部分结束 -->
							</div>
							<!-- 第三列结束 -->
							<!-- 第四列开始 -->
							<div>
								<!-- 1 -->
								<div class="r_block">
									<dv-border-box-8 :color="['#0575e6', '#00aaf2']">
										<right1 ref="right1"/>
									</dv-border-box-8>
								</div>
								<!-- 2 -->
								<div class="r_block">
									<dv-border-box-8 :color="['#0575e6', '#00daf2']">
										<right2 ref="right2"/>
									</dv-border-box-8>
								</div>
							</div>
							<!-- 第四列结束 -->
						</div>
					</div>
					<!-- 第三行数据结束 -->
				</div>

			</div>
		</dv-full-screen-container>
	</div>
</template>

<script>
	var storage = window.localStorage;
	var region = storage.getItem("region");
	var orgCode = storage.getItem("orgCode");

	import left1 from "./left1";
	import left2 from "./left2";
	import left3 from "./left3";
	import right1 from "./right1";
	import right2 from "./right2";
	import center1 from "./center1";
	import center2 from "./center2";
	export default {
		data() {
			return {
				loading: true,
				termIndex: 1,
				termName: '2023-2024第一学期',
				termFlag: false,
				termDorm: null,
				areaName: '',
				studentNum: 0,
				hasEvalNum: 0,
				notEvalNum: 0,
				fullscreen: false,
				screenName: "全屏"
			};
		},
		components: {
			left1,
			left2,
			left3,
			right1,
			right2,
			center1,
			center2
		},
		mounted() {
			this.cancelLoading();
			this.initData();
			// 定时刷新时间
			let _this = this;
			// 定时器刷新，1小时
			setInterval(() => {
				_this.initData();
			}, 1000 * 60 * 60);
		},
		watch: {
			termFlag: {
				handler(newVal, olVal) {
					console.log(olVal);
					if (newVal) {
						setTimeout(() => {
							document.addEventListener('click', this.termCheck);
						}, 0);
					} else {
						document.removeEventListener('click', this.termCheck);
					}
				}
			}
		},
		unmounted() {
			document.removeEventListener('click', this.termCheck);
		},
		methods: {
			//关闭loading加载条
			cancelLoading() {
				setTimeout(() => {
					this.loading = false;
				}, 2000);
			},
			initData() {
				let _this = this;
				var type = this.$route.query.type;
				//判断访问客户端类型
				if (type == 'window') {
					_this.screenName = "全屏";
				} else {
					_this.screenName = "返回";
				}
				this.$http.get("/dataView/getNameByRedion?regionId=" + region).then(res => {
					if (res.data.code === 200) {
						_this.areaName = res.data.result + '教育局';
					}
				});
				this.$http.get("/dataView/quality/edu/getIndexInfo?orgCode=" + orgCode + "&termName=" + _this.termName).then(res => {
					if (res.data.code === 200) {
						var result = res.data.result;
						_this.studentNum = result.partakeNum;
						_this.hasEvalNum = result.finishNum;
						_this.notEvalNum = result.unFinishNum;
					}
				});
			},
			// 下拉菜单选择学期
			termCheck(event) {
				let dom = this.$refs.termDorm;
				if (!dom.contains(event.target)) {
					if (this.termFlag) {
						this.termFlag = false;
						document.removeEventListener('click', this.termCheck);
					}
				}
			},
			//选择学期
			checkTerm(termName,index) {
				this.termIndex = index;
				this.termName = termName;
				this.termFlag = false;
				this.initData();
				this.$refs.left1.initData();
				this.$refs.left2.initData();
				this.$refs.left3.initData();
				this.$refs.center1.initData();
				this.$refs.center2.initData();
				this.$refs.right1.initData();
				this.$refs.right2.initData();
			},
			//点击全屏
			screen: function() {
				var type = this.$route.query.type;
				//判断访问客户端类型
				if (type == 'window') {
					let _this = this;
					let element = document.documentElement;
					if (_this.fullscreen) {
						if (document.exitFullscreen) {
							document.exitFullscreen();
						} else if (document.webkitCancelFullScreen) {
							document.webkitCancelFullScreen();
						} else if (document.mozCancelFullScreen) {
							document.mozCancelFullScreen();
						} else if (document.msExitFullscreen) {
							document.msExitFullscreen();
						}
						_this.screenName = "全屏";
					} else {
						if (element.requestFullscreen) {
							element.requestFullscreen();
						} else if (element.webkitRequestFullScreen) {
							element.webkitRequestFullScreen();
						} else if (element.mozRequestFullScreen) {
							element.mozRequestFullScreen();
						} else if (element.msRequestFullscreen) {
							element.msRequestFullscreen();
						}
						_this.screenName = "取消";
					}
					_this.fullscreen = !_this.fullscreen;
				}else{
					//window.AndroidWebView.finish();
					this.$router.replace('/dataView/appIndex?area=' + region);
				}
			}
		},
		// 注意在vue实例销毁前，清除我们的定时器。
		destroyed() {
			if (this.timer) {
				clearInterval(this.timer)
			}
		}
	};
</script>

<style lang="scss">
	@font-face {
		font-family: electronicFont;
		src: url("../../assets/font/DS-DIGI-1.ttf")
	}

	#qe_index {
		color: #d3d6dd;
		background-color: #181b37;
		width: 100%;
		min-height: 100vh;
		background: url("../../assets/img/qualitySchBg.mp4") no-repeat center 0px;
		background-size: 100% 100%;

		.full_screen {
			width: 0.8rem;
			height: 0.8rem;
			position: absolute;
			top: 0.32rem;
			right: 0.5rem;
			font-size: 0.2rem;
			color: #55ffff;
			font-weight: bold;
			-webkit-background-clip: text;
			background-image: linear-gradient(90deg, #55ffff, #55aaff);
			-webkit-text-fill-color: transparent;
			cursor: pointer;
		}

		.bg {
			padding: 0.2rem 0.2rem 0 0.2rem;
			background-position: center center;
		}

		video#bgvid {
			position: fixed;
			right: 0;
			bottom: 0;
			min-width: 100%;
			min-height: 100%;
			width: auto;
			height: auto;
			z-index: -100;
			background-size: cover;
		}

		.host-body {
			.title_bg {
				width: 100%;
				height: 8vh;
				background: url("../../assets/img/indextit_bg.png") center no-repeat;

				.title {
					width: 100%;
					text-align: left;

					.title-text {
						display: inline-block;
						font-size: 0.25rem !important;
						font-weight: bold;
						line-height: 0.25rem;
						margin-left: 0;
						margin-top: 0.25rem;
						background-image: linear-gradient(135deg, #55ffff, #54c3ff);
						-webkit-background-clip: text;
						color: transparent;
					}
				}
			}

			.body-box {
				display: flex;
				flex-direction: column;

				//下方区域的布局
				.main_grid {
					display: grid;
					grid-template-columns: 1fr 2fr 1fr;
				}
			}
		}

		.mt_block {
			width: 60%;
			height: 5vh;
			display: grid;
			grid-template-columns: 1fr 1fr 1fr;
			margin: 0 auto;
		}
	
		.b_block {
			text-align: center;
			background-size: 60%;
		}
	
		.block_bnum {
			font-size: 0.45rem;
			color: #55ffff;
			letter-spacing: 0.05rem;
			font-family: electronicFont;
			
		}
	
		.block_bnum .colorbluegreen {
			-webkit-background-clip: text;
			-webkit-text-fill-color: transparent;
			padding: 0 0 0 0.04rem;
			background-image: -webkit-gradient(linear, left top, right top, from(#00ffff), to(#00bbff));
			//background-image: linear-gradient(90deg, #55ffff, #55aaff);
			//background-image: linear-gradient(90deg, rgba(85, 85, 255, 0.3), rgba(0, 0, 0, 0.3));
		}
	
		.block_bnum .colorYellow {
			-webkit-background-clip: text;
			-webkit-text-fill-color: transparent;
			padding: 0 0 0 0.04rem;
			background-image: -webkit-gradient(linear, left top, right top, from(#40f5c2), to(#59ffa4));
		}
	
		.block_bnum .colorBlue {
			-webkit-background-clip: text;
			-webkit-text-fill-color: transparent;
			padding: 0 0 0 0.04rem;
			background-image: -webkit-gradient(linear, left top, right top, from(#ff7e80), to(#ff999b));
		}
	
		.title-item {
			color: #54beff;
			font-size: 0.18rem;
		}
	
		.r_block {
			margin: 0.15rem 0;
			height: 43.5vh;
		}
	
		.l_block {
			width: 100%;
			margin: 0.1rem 0;
			height: 29vh;
		}
	
		.center_mt {
			height: 53vh;
			margin: 0.12rem 0.1rem 0.15rem 0.1rem;
		}
	
		.center_btm {
			height: 29vh;
			margin: 0 0.1rem;
		}
	
		.title {
			line-height: 0.8rem;
	
			.title-text {
				font-size: 0.45rem !important;
				width: 100%;
				font-weight: 600;
				background-image: linear-gradient(135deg, #00c3d4, #7243e1);
				-webkit-background-clip: text;
				color: transparent;
			}
		}

		// 选择学期
		.term {
			position: absolute;
			top: 75px;
			right: 170px;
			z-index: 999;
		}

		.term_txt {
			width: 245px;
			height: 35px;
			line-height: 35px;
			background-image: linear-gradient(to right, #112d59, #01013b);
			border: 1px solid #00bbff;
			font-size: 0.2rem;
			padding: 0 10px;
			color: #00ddff;
			border-radius: 5px;
			cursor: pointer;
		}

		.term_txt span {
			float: right;
		}

		.term_list {
			width: 245px;
			background: rgba(1, 47, 103, 0.9);
			border-bottom-right-radius: 5px;
			border-bottom-left-radius: 5px;
			padding: 5px 0px;
			position: absolute;
			top: 35px;
			left: 0;
			cursor: pointer;
		}

		.term_list li {
			color: #00ddff;
			line-height: 34px;
			border-bottom: 1px dashed #005979;
			font-size: 0.2rem;
			padding: 0px 15px;
		}

		.term_list .on{
			background: #0575e6;
		}

		.term_list li a {
			color: #00ddff;
		}

		.term_list li:last-child {
			border: none
		}
	}

</style>